import useAppSelector from "@/core/helpers/useAppSelector";
import { stationSelector } from "@/domains/gasStation/slice";
import { headerImg } from "@/domains/gasStation/helpers/headerImg";
import GasStationHeader from "@/domains/gasStation/components/GasStationHeader";

export default function GasStationHeaderContainer() {
  const station = useAppSelector(stationSelector);

  return <GasStationHeader name={station.name} src={headerImg[station.brand]} />;
}
